import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { extendedMutationType } from '../../types';
import ToggleMutationButton from './ToggleMutationButton';

SuspensionButton.propTypes = {
    extendedMutation: extendedMutationType.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    isSuspended: PropTypes.bool.isRequired,
    extraConfirmationMessage: PropTypes.string,
    trueFlagText: PropTypes.string,
    falseFlagText: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

function SuspensionButton(props) {
    const {
        extendedMutation,
        confirmationMessage,
        extraConfirmationMessage = null,
        isSuspended,
        trueFlagText = null,
        falseFlagText = null,
        className = null,
        disabled = false,
    } = props;
    const { t } = useTranslation();
    return (
        <ToggleMutationButton
            className={`${className ? className + ' ' : ''}suspension-button button-bordered-orange`}
            confirmationMessage={confirmationMessage}
            extraConfirmationMessage={extraConfirmationMessage}
            extendedMutation={extendedMutation}
            showConfirmationDialog
            icon="user-clock"
            toggleFlag={isSuspended}
            trueFlagText={trueFlagText || t('button.unsuspend')}
            falseFlagText={falseFlagText || t('button.suspend')}
            disabled={disabled}
        />
    );
}

export default SuspensionButton;
